module.exports = __webpack_public_path__ + "img/table.ff3308fa.svg";